export function delete_tour_parameter_from_url(router) {
	// Create a copy of the current query params without the tour parameter
	const newQuery = Object.fromEntries(
		Object.entries(router.query).filter(([key]) => key !== "tour"),
	);

	// Update the URL without triggering a page reload
	router.replace(
		{
			pathname: router.pathname,
			query: newQuery,
		},
		undefined,
		{ shallow: true },
	);
}
